import { useNavigate, Link } from "react-router-dom";
import { useStore } from "../../store";
import { useEffect, useState } from "react";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import Button from "../../components/Button";
import MenuSettingWifi from "./Wifi";
import MenuSettingDate from "./Date";
import MenuSettingRegion from "./Region";
import MenuSettingScreensaver from "./Screensaver";
import MenuSettingScreenlock from "./Screenlock";
import MessageModal, { MessageModalProps } from "../../components/MessageModal";
function MenuSetting() {
  const navigate = useNavigate();

  const { dataStore } = useStore();
  const resData = toJS(dataStore).resData;

  const [type, setType] = useState("wifi");

  let onClickChooseType = function (str: string) {
    setType(str);
    if (str === "wifi") {
      dataStore.sendData({
        action: "loadWifi",
      });
    }
  };

  useEffect(() => {
    onClickChooseType("wifi");
  }, []);

  return (
    <div className="flex bg-quickStartPrimaryBgColor">
      <div className="absolute w-[1280px] h-[730px] flex">
        <div className="w-2/6 relative ">
          <div
            className="absolute border-4 bg-[#fbc986] rounded-2xl mt-[60px]
          w-[260px]
          pt-8
          pb-8
          pl-1
          ml-8
          "
          >
            <Button
              options={{
                text: "WI-FI",
                class: "bg-buttonRunBgColor text-lg px-8",
                cb: () => {
                  onClickChooseType("wifi");
                },
              }}
              style={{
                backgroundColor: "#406F70",
                fontSize: "24px",
                margin: 10,
                borderColor: type === "wifi" ? "white" : "transparent",
                borderStyle: "solid",
                borderWidth: "2px",
                width: '220px',
                boxShadow:
                  type === "wifi" ? "inset 1px 1px 5px 5px #2d5253" : undefined,
              }}
            />
            <Button
              options={{
                text: "DATE & TIME",
                class: "bg-buttonRunBgColor text-lg px-8",
                cb: () => onClickChooseType("date"),
                disabled: resData.activeLogAck?.state === 'ACTIVE'

              }}
              style={{
                backgroundColor: "#406F70",
                fontSize: "24px",
                margin: 10,
                borderColor: type === "date" ? "white" : "transparent",
                borderStyle: "solid",
                borderWidth: "2px",
                width: '220px',
                boxShadow:
                  type === "date" ? "inset 1px 1px 5px 5px #2d5253" : undefined,
              }}
            />

            <Button
              options={{
                text: "REGION & UNIT",
                class: "bg-buttonRunBgColor text-lg px-8",
                cb: () => onClickChooseType("region"),
              }}
              style={{
                backgroundColor: "#406F70",
                fontSize: "23px",
                margin: 10,
                borderColor: type === "region" ? "white" : "transparent",
                borderStyle: "solid",
                borderWidth: "2px",
                width: '220px',
                boxShadow:
                  type === "region"
                    ? "inset 1px 1px 5px 5px #2d5253"
                    : undefined,
              }}
            />

            <Button
              options={{
                text: "SCREENSAVER",
                class: "bg-buttonRunBgColor text-lg px-8",
                cb: () => onClickChooseType("screensaver"),
              }}
              style={{
                backgroundColor: "#406F70",
                fontSize: "24px",
                margin: 10,
                borderColor: type === "screensaver" ? "white" : "transparent",
                borderStyle: "solid",
                borderWidth: "2px",
                width: '220px',
                boxShadow:
                  type === "screensaver"
                    ? "inset 1px 1px 5px 5px #2d5253"
                    : undefined,
                  display: resData.defaultAck?.lowSpec ? "none" : "block"
              }}
            />
            {/* <Button
              options={{
                text: "SCREEN LOCK",
                class: "bg-buttonRunBgColor text-lg px-8",
                cb: () => onClickChooseType("screenlock"),
              }}
              style={{
                backgroundColor: "#406F70",
                fontSize: "24px",
                margin: 10,
                borderColor: type === "screenlock" ? "white" : "transparent",
                borderStyle: "solid",
                borderWidth: "2px",
                display: 'none',
                boxShadow:
                  type === "screenlock"
                    ? "inset 1px 1px 5px 5px #2d5253"
                    : undefined,
              }}
            /> */}
            {/* <Button
              options={{
                text: "ADMIN",
                class: "bg-buttonRunBgColor text-lg px-8",
                cb: () => onClickChooseType("admin"),
              }}
              style={{
                padding: "0px 40px",
                backgroundColor: "#406F70",
                fontSize: "24px",
                width: "280px",
                margin: 10,
                borderColor: type === "admin" ? "white" : "transparent",
                borderStyle: "solid",
                borderWidth: "2px",
                display: 'none',
              }}
            /> */}
          </div>
        </div>
        {type === "wifi" ? <MenuSettingWifi /> : null}
        {type === "date" ? <MenuSettingDate /> : null}
        {type === "region" ? <MenuSettingRegion /> : null}
        {type === "screenlock" ? <MenuSettingScreenlock /> : null}
        {type === "screensaver" ? <MenuSettingScreensaver /> : null}
      </div>

      <Button
        options={{
          text: "RETURN",
          class: "bg-buttonRunBgColor text-lg px-8 absolute inset-0 m-auto",
          cb: () => navigate(-1),
        }}
        style={{
          padding: "0px 40px",
          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
          backgroundColor: "#406F70",
          marginLeft: "55px",
          fontSize: "24px",
          top: "0",
          marginTop: '630px',
          width: '200px'
        }}
      />
    </div>
  );
}
export default observer(MenuSetting);
